import React from 'react';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import RepaymentYear from '../../components/RepaymentYear';
import {ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import fieldsToNumbers from '../../utils/fieldsToNumbers';
import {returnEquityCalculatorOutput} from './calculations/equityCalculatorCalculations';
import currencyFormatter from '../../utils/currencyFormatter';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import EquityAssumptionContent from './AssumptionBoxContent/EquityAssumptionContent';
const interestRate = I18n.t('calculators.interest_matrix.live.regular.payg_variable')[0];

class EquityCalculator extends React.Component {
  state = {
    propertyValue: 1000000,
    outstandingLoanBalance: 250000,
    interestRate,
    remainingLoanTerm: 30,
    propertyIntent: 'rent',
    sellingAgentFee: 0,
    conveyancingFee: 1000,
    otherCosts: 0,
    errors: {},
  };

  onCalculationSuccess = (response) => {
    this.setState({results: response.data})
  };

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors;

    let swalTitle = I18n.t('calculators.generic_error.title');
    let swalText = I18n.t('calculators.generic_error.description');

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title');
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  };

  onCalculationSubmit = () => {
    const {
      propertyValue,
      outstandingLoanBalance,
      interestRate,
      remainingLoanTerm,
      propertyIntent,
      sellingAgentFee,
      conveyancingFee,
      otherCosts,
    } = this.state;

    const equity = {
      propertyValue,
      outstandingLoanBalance,
      interestRate: interestRate / 100,
      remainingLoanTerm,
      propertyIntent,
      sellingAgentFee,
      conveyancingFee,
      otherCosts,
    };

    // let data = {
    //   offset: offset,
    // };

    let calculationResults = returnEquityCalculatorOutput(fieldsToNumbers(equity));
    this.setState({results: calculationResults});

    // postOffset(
    //   data,
    //   this.onCalculationSuccess,
    //   this.onCalculationFailure
    // );

  };

  componentDidMount = () => {
    this.onCalculationSubmit()
  };


  expandingLead = (
    <React.Fragment>
      <p>Home equity is the difference between your current property value and the outstanding balance on your home loan. If you have owned the property for some time, it is likely that you have accumulated some equity. The reason why home equity is useful is because you can use it as a deposit towards your next property purchase.</p>
      <p>Estimate your available equity using our home equity calculator.</p>
    </React.Fragment>
  );
  expandingInfoContent = (
    <React.Fragment>
      <p>To estimate your available equity, start by entering the property market value, outstanding loan balance, interest rate and remaining loan term. </p>
      <p>Then you should indicate whether you are planning to keep the property and rent it out, or sell it as this would impact the amount of available equity.</p>
      <p>Planning to rent out the property: Your available equity equals the market value of the property minus the outstanding loan balance up to 80% loan-to-value ratio. For example, if your property is worth $1,000,000 and your outstanding loan is $500,000, your available equity is $300,000.</p>
      <p>Planning to sell the property: Your available equity is determined by the market value of your property minus your oustanding mortgage and any selling costs. Typical selling costs to factor are real estate agent fees and conveyancing fees. </p>
      <p>Next steps are to determine whether leveraging the equity in your property will give you the sufficient deposit amount and borrowing capacity to purchase your next property.</p>
    </React.Fragment>
  );
  
  handlePropertyIntentChange(value) {
    const newValues = value === 'rent' ? {
      propertyIntent: value,
      sellingAgentFee: 0,
      conveyancingFee: 0,
      otherCosts: 0,
    } : {
      propertyIntent: value,
      sellingAgentFee: 0,
      conveyancingFee: 1000,
      otherCosts: 0,
    };
    
    this.setState({...newValues});

    const {
      propertyValue,
      outstandingLoanBalance,
      interestRate,
      remainingLoanTerm,
    } = this.state;

    const equity = {
      propertyValue,
      outstandingLoanBalance,
      interestRate: interestRate / 100,
      remainingLoanTerm,
      ...newValues
    };
    
    let calculationResults = returnEquityCalculatorOutput(fieldsToNumbers(equity));
    this.setState({results: calculationResults});
  }
  
  calculatorForm() {
    const {
      propertyValue,
      outstandingLoanBalance,
      interestRate,
      remainingLoanTerm,
      propertyIntent,
      sellingAgentFee,
      conveyancingFee,
      otherCosts,
      errors,
    } = this.state;
    
    return (
      <React.Fragment>
        <div className="numeric-input">
          <InputWithLabel
            label='Property value'
            type='currency'
            defaultValue={propertyValue}
            errorMessage={errors['propertyValue']}
            onChange={(value) => this.setState({propertyValue: value})}
          />
        </div>
        <div className="numeric-input">
          <InputWithLabel
            label='Outstanding loan balance'
            type='currency'
            defaultValue={outstandingLoanBalance}
            errorMessage={errors['outstandingLoanBalance']}
            onChange={(value) => this.setState({outstandingLoanBalance: value})}
          />
        </div>
        <div className="rate-input">
          <InputWithLabel
            label='Interest rate'
            type='append'
            defaultValue={interestRate}
            errorMessage={errors['interestRate']}
            onChange={(value) => this.setState({interestRate: value})}
          />
        </div>
        <RepaymentYear
          label='Loan term (years)'
          defaultValue={remainingLoanTerm}
          onChange={(value) => this.setState({remainingLoanTerm: value})}
        />
        <div className="equity-calculator__toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                             type="radio"
                             name="options"
                             defaultValue={'rent'}
                             onChange={ (value) => { this.handlePropertyIntentChange(value) } }>
            <ToggleButton className='btn onboarding-form' value="rent">Rent property</ToggleButton>
            <ToggleButton className='btn onboarding-form' value="sell">Sell property</ToggleButton>
          </ToggleButtonGroup>
        </div>
        {
          propertyIntent === 'sell' && (
            <div className="equity-calculator__sell-property-fields">
              <div className="numeric-input">
                <InputWithLabel
                  label='Selling agent fee'
                  type='currency'
                  defaultValue={sellingAgentFee}
                  errorMessage={errors['sellingAgentFee']}
                  onChange={(value) => this.setState({sellingAgentFee: value})}
                />
              </div>
              <div className="numeric-input">
                <InputWithLabel
                label='Conveyancing fee'
                type='currency'
                defaultValue={conveyancingFee}
                errorMessage={errors['conveyancingFee']}
                onChange={(value) => this.setState({conveyancingFee: value})}
                />
              </div>
              <div className="numeric-input">
                <InputWithLabel
                label='Other costs'
                type='currency'
                defaultValue={otherCosts}
                errorMessage={errors['otherCosts']}
                onChange={(value) => this.setState({otherCosts: value})}
                />
              </div>
            </div>
          )
        }
      </React.Fragment>
    )
  }

  resultsColumn() {
    const {results} = this.state;
    return results ? <div>
      <div className="calculator-result-card-set">
        {
          this.state.propertyIntent === 'rent' ? (
            <React.Fragment>
              <CalculatorResultCard
                caption='Available equity'
                figure={currencyFormatter.format(results.availableEquity)}
              />
              <CalculatorResultCard
                caption='New loan balance'
                figure={currencyFormatter.format(results.newLoanBalance)}
              />
              <CalculatorResultCard
                caption='New monthly repayment'
                figure={currencyFormatter.format(results.newMonthlyRepayment)}
              />
            </React.Fragment>
          ) : (
            <CalculatorResultCard
              caption='Available equity'
              figure={currencyFormatter.format(results.availableEquity)}
            />
          )
        }
      </div>
      <CalculatorCallToActionCard>
        <div className='equity-calculator__cta'>
          <p className='equity-calculator__cta-text regular-cta'>Ready to get started?</p>
        </div>
      </CalculatorCallToActionCard>
    </div> : null;
  }
  
  render() {
    return (
      <div className="equity-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo lead={this.expandingLead}>{this.expandingInfoContent}</ExpandingInfo>}
          formColumn={
            <React.Fragment>
              <CalculatorForm handleSubmit={this.onCalculationSubmit}>{this.calculatorForm()}</CalculatorForm>
            </React.Fragment>
          }
          resultsColumn={this.resultsColumn()}
        >
          <CalculatorAssumptions assumptionBoxContents={<EquityAssumptionContent />} />
        </CalculatorLayout>
      </div>
    );
  }
}

export default EquityCalculator;
